import { render, staticRenderFns } from "./PublishedContent.vue?vue&type=template&id=2ad72b77&"
import script from "./PublishedContent.vue?vue&type=script&lang=js&"
export * from "./PublishedContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports